import $ from 'jquery';
import MailcheckStella from 'legacy/javascripts/mailcheck_stella.js';
import { Bloodhound, loadjQueryPlugin } from 'corejs-typeahead/index.js';
loadjQueryPlugin();

$(function () {
  var errorCount = 0;
  var pollCount = 0;
  var maxErrorCount = 3;
  var maxPollCount = 100;
  window.pollForUpdate = function () {
    var pollUrl = $('div#update-polling').data('ready-status');
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: pollUrl,
      success: function (data) {
        pollCount += 1;
        if (data.preview_ready) {
          window.location.href = $('div#update-polling').data('preview-url');
        } else {
          if (pollCount > maxPollCount) {
            $('.js-bulk-management-loading-indicator').addClass('hidden');
            $('.js-bulk-management-error').removeClass('hidden');
          } else {
            window.setTimeout(window.pollForUpdate, 5000);
          }
        }
      },
      error: function () {
        errorCount += 1;
        if (errorCount > maxErrorCount) {
          $('.js-bulk-management-loading-indicator').addClass('hidden');
          $('.js-bulk-management-error').removeClass('hidden');
        } else {
          window.setTimeout(window.pollForUpdate, 5000);
        }
      },
    });
  };

  var exceededLicenseModal = $('#js-exceeded-license-modal');
  var changeFunction = function () {
    $('#update_employee_button').click(function (e) {
      var result;
      if ($('#employee_company_admin').is(':checked')) {
        result = window.confirm(
          'Are you sure you want to add an additional company admin?',
        );
        if (result === false) {
          e.preventDefault();
        }
      } else {
        result = window.confirm(
          'Are you sure you want to make this admin a non-admin manager?',
        );
        if (result === false) {
          e.preventDefault();
        }
      }
    });
  };
  var language = {
    paginate: {
      previous: ' ',
      next: ' ',
    },
    lengthMenu: 'Per page: _MENU_',
  };
  var csvButton = {
    extend: 'csv',
    text: 'Download',
    className: 'btn-secondary',
  };

  $('section.accounts').on('click', '.deactivate-employee', function (e) {
    var employeeId = $(this).data('employeeId');
    e.preventDefault();
    if (
      window.confirm('Are you sure you want to deactivate this team member?')
    ) {
      $('.js-deactivate-employee-shadow-link[data-employee-id=' + employeeId + ']').click();
    };
  });

  $('#employee_company_admin').change(changeFunction);

  $('form#new_employee #employee_email, form.edit_employee #employee_email').on(
    'blur',
    MailcheckStella.check,
  );

  $('.js-data-table-rewards-votes').each(function (index, table) {
    $('.js-data-table-rewards-votes th.agent-name').each(function () {
      $(this).append(
        '<input type="text" placeholder="Search team member" class="form-control column-filter" />',
      );
    });

    $(table)
      .DataTable({
        dom: 'rt <"dataTablesFilterAndLength"lB>p',
        buttons: [csvButton],
        language: language,
        stateSave: true,
      })
      .columns()
      .every(function () {
        var that = this;

        $('input.column-filter', this.header()).on('keyup change', function () {
          // see https://datatables.net/examples/api/multi_filter.html
          if (that.search() !== this.value) {
            that.search(this.value).draw();
          }
        });

        $('input.column-filter', this.header()).click(function (event) {
          event.stopPropagation();
        });

        $('input.column-filter').trigger('change');
      });
  });

  $('.js-data-table-rewards-report').each(function (index, table) {
    $('.js-data-table-rewards-report th.agent-name').each(function () {
      $(this).append(
        '<input type="text" placeholder="Search team member" class="form-control column-filter" />',
      );
    });

    $(table)
      .DataTable({
        dom: 'rt <"dataTablesFilterAndLength"B>p',
        buttons: [csvButton],
        paging: false,
        language: language,
        stateSave: true,
        columnDefs: [{ width: '30%', targets: 0 }],
      })
      .columns()
      .every(function () {
        var that = this;

        $('input.column-filter', this.header()).on('keyup change', function () {
          // see https://datatables.net/examples/api/multi_filter.html
          if (that.search() !== this.value) {
            that.search(this.value).draw();
          }
        });

        $('input.column-filter', this.header()).click(function (event) {
          event.stopPropagation();
        });

        $('input.column-filter').trigger('change');
      });
  });

  $('.js-data-table-with-col-sort').each(function (index, table) {
    $(
      '.js-data-table-with-col-sort th.agent-name, .js-data-table-with-col-sort th.reward',
    ).each(function () {
      $(this).append(
        '<br><input type="text" placeholder="Search" class="form-control column-filter" />',
      );
    });

    $(table)
      .DataTable({
        dom: 'rt <"dataTablesFilterAndLength"lB>p',
        buttons: [
          {
            ...csvButton,
            exportOptions: {
              format: {
                header: function (data, row, column, node) {
                  let div = document.createElement('div');
                  div.innerHTML = data;
                  return div.firstChild.data.trim();
                },
              },
              columns: ':visible',
            },
          },
        ],
        language: language,
        stateSave: true,
        ordering: true,
        columnDefs: [
          { width: '30%', targets: 0 },
          { width: '25%', targets: 1 },
          { width: '25%', targets: 2 },
          { width: '20%', targets: 3 },
          { targets: 4, visible: false },
          { bSortable: false, aTargets: [-1] },
          { bSortable: true, aTargets: ['_all'] },
        ],
      })
      .columns()
      .every(function () {
        var that = this;

        $('input.column-filter', this.header()).on('keyup change', function () {
          // see https://datatables.net/examples/api/multi_filter.html
          if (that.search() !== this.value) {
            that.search(this.value).draw();
          }
        });

        $('input.column-filter, #js-fulfill-all-button', this.header()).click(
          function (event) {
            event.stopPropagation();
          },
        );

        $('input.column-filter').trigger('change');
      });

    $(table)
      .DataTable()
      .on('draw', function () {
        const fulfilled_ids = $('#fulfilled_ids').val();
        const fulfilled_ids_array = fulfilled_ids ? fulfilled_ids.split(',') : [];
        fulfilled_ids_array.forEach(earnedRewardId => {
          const fulfillRewardBtn = $(
            '.js-fulfill-earned-reward[data-earned-reward-id="' +
              earnedRewardId +
              '"]',
          );
          fulfillRewardBtn.prop('disabled', true);
        });
      });
  });

  $('.js-reset-default-image').click(function (e) {
    var defaultImage = $('.js-default-image').data('default');
    var newImage = $('img.profile-image').clone().attr('src', defaultImage);
    e.preventDefault();
    $('img.profile-image').replaceWith(newImage);
    $('#image').attr('value', defaultImage);
    $(this).addClass('hidden');
    $('.js-default-copy').removeClass('hidden');
  });

  if (exceededLicenseModal.length) {
    $('input#js-submit-bulk-invitations-preview').click(function (e) {
      e.preventDefault();
      exceededLicenseModal.modal('show');
    });

    $('.js-bulk-continue').click(function (e) {
      e.preventDefault();
      exceededLicenseModal.modal('show');
    });

    $('.js-confirm-license').click(function (e) {
      e.preventDefault();
      exceededLicenseModal
        .find('.js-license-confirm-action a')
        .attr('href', this.href);
      exceededLicenseModal.modal('show');
    });

    var $exceededLimitAck = $('.js-cap-acknowledgement');
    if ($exceededLimitAck.length) {
      $('.js-license-confirm-action a.btn-primary').click(function (e) {
        e.preventDefault();
        if ($exceededLimitAck.is(':checked')) {
          window.location.href = $(this).attr('href');
        }
        return false;
      });

      $exceededLimitAck.on('change', function () {
        $('.js-license-confirm-action .btn-primary').attr(
          'disabled',
          this.checked ? false : true,
        );
      });
    }
  }

  $('.js-reset-password-link').on('click', function () {
    $('.js-reset-password-form').submit();
  });

  const escape = str => {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };
    return str.replace(/[&<>"']/g, m => map[m]);
  };

  const bloodhoundObject = data => {
    return new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      local: Object.keys(data),
    });
  };

  const typeaheadOptions = () => {
    return {
      hint: true,
      highlight: true,
      minLength: 1,
    };
  };

  const typeaheadDataset = (name, source) => {
    return {
      name: name,
      source: source,
      templates: {
        suggestion: function (data) {
          return '<span data-notranslate>' + escape(data) + '</span>';
        },
      },
    };
  };

  const localeDropdownData = {};
  const $localeSelector = $('input.locale-typeahead + select');
  const $localeTypeahead = $('.locale-typeahead');

  $('option', $localeSelector).each(function (index, elem) {
    localeDropdownData[elem.text] = elem.value;
  });
  const locales = bloodhoundObject(localeDropdownData);

  $localeTypeahead.typeahead(
    typeaheadOptions,
    typeaheadDataset('locales', locales),
  );
  $localeTypeahead.typeahead(
    'val',
    $('option:selected', $localeSelector).text(),
  );
  $localeTypeahead.bind('typeahead:change', function (ev, suggestion) {
    if (localeDropdownData[suggestion] === undefined) {
      const optionSelectValue = $('option:selected', $localeSelector).text();
      $localeTypeahead.typeahead('val', optionSelectValue);
    } else {
      $localeSelector.val(localeDropdownData[suggestion]);
    }
  });

  const supervisorDropdownData = {};
  const $supervisorSelector = $('input.typeahead + select');
  const $teamTypeahead = $('.typeahead');

  $('option', $supervisorSelector).each(function (index, elem) {
    supervisorDropdownData[elem.text] = elem.value;
  });
  const supervisors = bloodhoundObject(supervisorDropdownData);

  $teamTypeahead.typeahead(
    typeaheadOptions,
    typeaheadDataset('supervisors', supervisors),
  );
  $teamTypeahead.typeahead(
    'val',
    $('option:selected', $supervisorSelector).text(),
  );
  $teamTypeahead.bind('typeahead:change', function (ev, suggestion) {
    if (supervisorDropdownData[suggestion] === undefined) {
      const optionSelectValue = $(
        'option:selected',
        $supervisorSelector,
      ).text();
      $teamTypeahead.typeahead('val', optionSelectValue);
    } else {
      $supervisorSelector.val(supervisorDropdownData[suggestion]);
    }
  });

  $teamTypeahead.click(function () {
    $(this).select();
  });

  // Expand Reporting Groups on page load
  $('.field.reporting-group-memberships .reporting-groups').each(function () {
    if ($(this).find('input:checked').length) {
      $(this).addClass('in');
    }
  });

  const initialTeamLeader = $('#employee_supervisor').first().val();

  $teamTypeahead.bind('typeahead:select', function (ev, suggestion) {
    var event = $.Event(
      suggestion === initialTeamLeader
        ? 'reportingGroups.enable'
        : 'reportingGroups.disable',
    );

    $('.field.reporting-group-memberships').trigger(event);
  });

  $('.panel.collapse.reporting-groups').on(
    'show.bs.collapse',
    function (collapsible) {
      $('#' + collapsible.target.id + '-icon')
        .removeClass('fa-caret-right')
        .addClass('fa-caret-down');
    },
  );

  $('.panel.collapse.reporting-groups').on(
    'hide.bs.collapse',
    function (collapsible) {
      $('#' + collapsible.target.id + '-icon')
        .removeClass('fa-caret-down')
        .addClass('fa-caret-right');
    },
  );

  $('.field.reporting-group-memberships').on(
    'reportingGroups.enable',
    function (event) {
      $('#reporting-group-warning').hide();

      $(event.target).find('input').prop('disabled', false);
      $(event.target).css('opacity', '1.0');
    },
  );

  $('.field.reporting-group-memberships').on(
    'reportingGroups.disable',
    function (event) {
      $('#reporting-group-warning').show();

      $(event.target).find('input').prop('disabled', true);
      $(event.target).css('opacity', '0.5');
    },
  );
});
